/* eslint-disable */
import { PERMISSIONS } from 'app/core/auth/auth-types';
import { AppConstants } from 'app/core/constants/constants';
import { PermissionNavigationItem } from 'app/core/navigation/navigation.types';

export const defaultNavigation: PermissionNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'navigation.dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: `/${AppConstants.dashboard}`,
        permissions: [PERMISSIONS.DASHBOARD_READ],
    },
    {
        id: 'company',
        title: 'navigation.company',
        type: 'collapsable',
        icon: 'heroicons_outline:building-office',
        children: [
            {
                id: 'company-infos',
                title: 'navigation.company_infos',
                type: 'basic',
                link: `/${AppConstants.company}/${AppConstants.viewCompany}`,
                permissions: [PERMISSIONS.COMPANY_READ],
            },
        ],
    },
    {
        id: 'products',
        title: 'navigation.products',
        type: 'collapsable',
        icon: 'heroicons_outline:shopping-bag',
        children: [
            {
                id: 'products',
                title: 'navigation.products',
                type: 'basic',
                link: `/${AppConstants.products}`,
                permissions: [PERMISSIONS.PRODUCT_READ],
            },
            {
                id: 'product_family',
                title: 'navigation.product_family',
                type: 'basic',
                link: `/${AppConstants.productFamily}`,
                permissions: [PERMISSIONS.PRODUCT_READ],
            },
            {
                id: 'inventory-reconciliation',
                title: 'navigation.inventory_reconciliation',
                type: 'basic',
                link: `/${AppConstants.inventoryReconciliation}`,
                permissions: [PERMISSIONS.RECONCILIATION_READ],
            },
        ],
    },
    {
        id: 'sales',
        title: 'navigation.sales',
        type: 'collapsable',
        icon: 'heroicons_outline:shopping-cart',
        children: [
            {
                id: 'customers',
                title: 'navigation.customers',
                type: 'basic',
                link: `/${AppConstants.customers}`,
                permissions: [PERMISSIONS.CUSTOMER_READ],
            },
            {
                id: 'sale-orders',
                title: 'navigation.sale_orders',
                type: 'basic',
                link: `${AppConstants.sales}/${AppConstants.saleOrders}`,
                permissions: [PERMISSIONS.SALE_ORDER_READ],
            },
            {
                id: 'sale-quotations',
                title: 'navigation.sale_quotations',
                type: 'basic',
                link: `${AppConstants.sales}/${AppConstants.saleQuotations}`,
                permissions: [PERMISSIONS.SALES_QUOTATION_READ],
            },
        ],
    },
    {
        id: 'purchasing',
        title: 'navigation.purchasing',
        type: 'collapsable',
        icon: 'heroicons_outline:truck',
        children: [
            {
                id: 'suppliers',
                title: 'navigation.suppliers',
                type: 'basic',
                link: `/${AppConstants.suppliers}`,
                permissions: [PERMISSIONS.SUPPLIER_READ],
            },
            {
                id: 'purchase-orders',
                title: 'navigation.purchase_orders',
                type: 'basic',
                link: `/${AppConstants.purchaseOrders}/purchase-orders`,
                disabled: false,
                permissions: [PERMISSIONS.PURCHASE_ORDER_READ],
            },
        ],
    },
    {
        id: 'marketing',
        title: 'navigation.marketing',
        type: 'collapsable',
        icon: 'heroicons_outline:tag',
        children: [
            {
                id: 'discounts',
                title: 'navigation.discounts',
                type: 'basic',
                link: `/${AppConstants.discounts}`,
                permissions: [PERMISSIONS.DISCOUNT_READ],
            },
            {
                id: 'marketplace',
                title: 'navigation.company_marketplace',
                type: 'basic',
                link: `/${AppConstants.marketing}/${AppConstants.marketplace}`,
                permissions: [PERMISSIONS.MARKETPLACE_READ],
            },
        ],
    },
    {
        id: 'team',
        title: 'navigation.team',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'members',
                title: 'navigation.members',
                type: 'basic',
                link: `/${AppConstants.team}/members`,
                permissions: [PERMISSIONS.TEAM_READ],
            },
            {
                id: 'roles',
                title: 'navigation.roles',
                type: 'basic',
                link: `/${AppConstants.team}/roles`,
                permissions: [PERMISSIONS.ROLE_READ],
            },
        ],
    },
];

export const compactNavigation: PermissionNavigationItem[] = defaultNavigation;
export const futuristicNavigation: PermissionNavigationItem[] =
    defaultNavigation;
export const horizontalNavigation: PermissionNavigationItem[] =
    defaultNavigation;
